import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "box-row",
  style: {"height":"unset"}
}
const _hoisted_2 = {
  class: "header flex tw-w-full sm:tw-w-auto",
  style: {"height":"52px"}
}
const _hoisted_3 = {
  key: 0,
  class: "tw-pl-2 tw-border tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b-1 tw-border-slate-200"
}
const _hoisted_4 = { class: "tw-flex items-center tw-flex-row" }
const _hoisted_5 = {
  key: 0,
  class: "tw-text-slate-400 tw-pr-2 tw-flex items-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "tw-text-sm tw-text-slate-600" }
const _hoisted_8 = {
  key: 0,
  class: "content tw-border tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b-1 tw-border-slate-200 flex justify-end"
}

import { computed, PropType } from 'vue';
    import { Screen } from 'quasar';
    
    import type { TabProps } from 'src/types/controls';
    import { useScreenSize } from 'src/functions';
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
        tabs: {
            type: Array as PropType<TabProps[]>,
            default: []
        },
        modelValue: {
            type: String,
            default: ''
        },
        simple: {
            type: Boolean,
            default: false
        },
        align:{
            type: String,
            default: 'center' 
        }
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    const props = __props

    const value = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val)
    })

    const emit = __emit

    const screen = useScreenSize();

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!__props.simple)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(_component_q_tabs, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        "no-caps": "",
        align: "left",
        "switch-indicator": !__props.simple,
        "indicator-color": "primary",
        class: "thick-indicator tw-w-full md:tw-w-auto",
        "mobile-arrows": "",
        "left-icon": "mdi",
        "right-icon": "mdi"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
            return (_openBlock(), _createBlock(_component_q_tab, {
              key: 'tab'+index,
              name: tab.name,
              class: _normalizeClass(["", __props.simple ? '' : value.value === tab.name ? 'tw-border tw-border-solid tw-bg-white tw-border-slate-200 tw-border-b-0' : 'tw-border tw-border-solid tw-border-slate-200 tw-border tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b-1']),
              disable: tab.disable || tab.loading
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["tw-flex column", __props.align === 'left' ? 'tw-items-start' : __props.align === 'right' ? 'tw-items-end' : 'tw-items-center'])
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    (tab.icon && _unref(screen).gt('sm'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon+'Icon')))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["tw-text-sm", value.value === tab.name ? 'tw-font-bold' : 'tw-px-[2px] tw-font-medium'])
                    }, _toDisplayString(tab.label), 3)
                  ]),
                  (tab.subLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(tab.subLabel), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 2
            }, 1032, ["name", "disable", "class"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "switch-indicator"])
    ]),
    (!__props.simple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}
}

})